<template>
  <v-container fluid>
    <v-row class="login-container">
      <v-col md="6" class="left-panel">
        <div class="background-right"></div>
      </v-col>

      <v-col cols="12" md="6" class="right-panel pa-0">
        <div class="background-left px-lg-8 px-md-8 px-sm-8">
          <v-row class="rowLogin px-lg-16 px-12 py-4">
            <v-col cols="12"></v-col>

            <v-col cols="12" class="pa-0" align-self="center">
              <v-slide-y-transition mode="out-in">
                <v-row class="pa-0" key="login" v-if="!esqueciSenha">
                  <v-col cols="12">
                    <div class="tituloInicial">
                      Seja Bem Vindo ao
                      <p class="nomeSistema">SIGU</p>
                    </div>
                    <div class="subtituloInicial">Preencha os campos abaixo para fazer o seu login.</div>
                  </v-col>

                  <v-col cols="12" class="py-1">
                    <v-expand-transition>
                      <v-alert v-show="mensagemErro.erro" color="red" border="left" text dense class="mb-0">
                        {{ mensagemErro.text }}
                      </v-alert>
                    </v-expand-transition>
                  </v-col>

                  <v-col cols="12">
                    <v-form v-model="isFormValid" @submit.prevent="login">
                      <v-row>
                        <v-col cols="12" class="pb-2">
                          <div class="labelCampo">Email</div>
                          <v-text-field v-model="email" placeholder="Insira o seu email" name="email" dense outlined filled hide-details prepend-inner-icon="mdi-email-outline" type="email" :rules="[requiredEmail(), emailFormat()]" />
                        </v-col>
                        <v-col cols="12" class="py-1">
                          <div class="labelCampo">Senha</div>
                          <v-text-field
                            v-model="senha"
                            placeholder="Insira a sua senha"
                            name="senha"
                            dense
                            outlined
                            filled
                            hide-details
                            prepend-inner-icon="mdi-lock-outline"
                            :type="show ? 'text' : 'password'"
                            :append-icon="show ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                            @click:append="show = !show"
                            :rules="[requiredSenha(), minLength(3)]"
                          />
                        </v-col>
                        <!-- <v-col cols="12" class="py-1" align="end">
                          <v-btn text plain small class="blue--text pt-1 pb-0 px-0" @click="esqueciSenha = true">Esqueceu sua Senha?</v-btn>
                        </v-col> -->
                        <v-col cols="12">
                          <v-btn id="login-button" block type="submit" :disabled="!isFormValid || isLoginButtonDisable" ref="login-button" elevation="0"> Entrar </v-btn>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-col>
                </v-row>

                <v-row class="pa-0" key="senha" v-else>
                  <v-col cols="12">
                    <div class="tituloInicial">
                      Esqueci a senha
                      <p class="nomeSistema">SIGU</p>
                    </div>
                    <div class="subtituloInicial">Preencha seu email no campo a baixo para receber uma nova senha.</div>
                  </v-col>

                  <v-col cols="12" class="py-1">
                    <v-expand-transition>
                      <v-alert v-show="mensagemSenha.erro" :color="mensagemSenha.cor" border="left" text dense class="mb-0">
                        {{ mensagemSenha.text }}
                      </v-alert>
                    </v-expand-transition>
                  </v-col>
                  <v-col cols="12">
                    <v-form v-model="isFormValid" @submit.prevent="login">
                      <v-row>
                        <v-col cols="12" class="pb-2">
                          <div class="labelCampo">Email</div>
                          <v-text-field v-model="email" placeholder="Insira o seu email" name="email" dense outlined filled hide-details prepend-inner-icon="mdi-email-outline" type="email" :rules="[requiredEmail(), emailFormat()]" autocomplete="off" />
                        </v-col>
                        <v-col cols="12" class="py-1" align="end">
                          <v-btn text plain small class="blue--text pt-1 pb-0 px-0" @click="esqueciSenha = false">Voltar</v-btn>
                        </v-col>
                        <v-col cols="12">
                          <v-btn id="send-button" block type="submit" :disabled="!isFormValid || isLoginButtonDisable" ref="send-button" elevation="0"> Enviar </v-btn>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-col>
                </v-row>
              </v-slide-y-transition>
            </v-col>

            <v-col cols="12" class="pa-0" align-self="end">
              <div class="textoSuporte">
                Em caso de dúvida, entre em contato com nosso suporte
                <a :href="'//api.whatsapp.com/send?phone=+5515991665796&text=Olá, estou com uma dúvida sobre o sistema SIGU'" target="_blank" rel="noopener noreferrer" class="font-weight-medium" title="Contato Suporte">(15) 99166-5796</a>
              </div>
              <div class="textoEmpresa pt-4">UP - Tecnologia em sistemas</div>
              <div class="textoEmpresa">&copy; 2019 - {{ new Date().getFullYear() }}. Todos os direitos reservados.</div>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import validation from "@/utils/validation";
import axios from "@/plugins/axios";
// import ModalCustomSize from "../components/ModalCustomSize";

export default {
  components: {
    // ModalCustomSize,
  },

  data() {
    return {
      ...validation,

      show: false,
      isFormValid: false,
      isLoginButtonDisable: false,

      email: "",
      senha: "",
      esqueciSenha: false,

      mensagemErro: {
        erro: false,
        text: "",
      },

      mensagemSenha: {
        erro: false,
        cor: "",
        text: "",
      },
    };
  },

  watch: {
    validateEmail() {
      this.modalCustomSize.forgotPassword.emailInserido = this.validateEmail;
      this.validateIfEmailExists(this.modalCustomSize.forgotPassword);
    },

    esqueciSenha() {
      this.mensagemErro.text = "";
      this.mensagemErro.erro = false;

      this.mensagemSenha.text = "";
      this.mensagemSenha.cor = "";
      this.mensagemSenha.erro = false;
    },
  },

  methods: {
    async login() {
      this.isLoginButtonDisable = true;
      try {
        if (!this.esqueciSenha) {
          const response = await axios.post("/login", {
            descricaoEmail: this.email,
            descricaoSenha: this.senha,
          });

          await this.$store.dispatch("setToken", response.data.token);
          await this.$store.dispatch("setAuthenticatedState", true);
          await this.$store.dispatch("setNivelUsuario", response.data.nivel);
          await this.$store.dispatch("setNome", response.data.nome);
          await this.$store.dispatch("setNumeroEndereco", response.data.enderecoOrdemServico.numeroEnderecoOrdemServico);
          await this.$store.dispatch("setNomeEndereco", response.data.enderecoOrdemServico.nomeEndereco);

          if (response.data.nivel == 1 || response.data.nivel == 3 || response.data.nivel == 5) {
            this.$router.push("/");
          } else if (response.data.nivel == 2) {
            this.$router.push("/receberProduto");
          }
        } else {
          console.log("Esqueci senha");
          // const response = await axios.post("/esqueciAsenha", { email: this.email });
          // if (response.data.usuarioEncontrado) {
          //   this.mensagemSenha.text = response.data.status;
          //   this.mensagemSenha.cor = "green";
          //   this.mensagemSenha.erro = true;
          //   this.esqueciSenha = false;
          // } else {
          //   this.mensagemSenha.text = response.data.status;
          //   this.mensagemSenha.cor = "red";
          //   this.mensagemSenha.erro = true;
          // }
        }
      } catch (error) {
        console.error(error);
        if (!this.esqueciSenha) {
          this.mensagemErro.text = error.response.data.message;
          this.mensagemErro.erro = true;
          this.senha = "";
        } else {
          this.mensagemSenha.text = error.response.data.message;
          this.mensagemSenha.cor = "red";
          this.mensagemSenha.erro = true;
        }
      } finally {
        this.isLoginButtonDisable = false;
      }
    },

    async validateIfEmailExists(email) {
      try {
        let validate = await axios.put("/validateEmail", email);
        if (validate.data) {
          this.mensagemModal.erro = false;
          this.modalCustomSize.isButtonsDisabled = false;
          this.modalCustomSize.forgotPassword.nomeFuncionario = validate.data.nomeFuncionario;
        } else {
          this.mensagemModal.erro = true;
          this.mensagemModal.text = "O email inserido não é válido!";
          this.modalCustomSize.isButtonsDisabled = true;
          this.modalCustomSize.forgotPassword.nomeFuncionario = false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async sendEmailForForgotPassword() {
      try {
        await axios.put("/sendEmail", this.modalCustomSize.forgotPassword);
        this.snackbar = true;
        this.modalCustomSize.isOpen = false;
      } catch (error) {
        console.log(error);
      }
    },

    openModalForgotMyPassword() {
      this.modalCustomSize.isOpen = true;
      this.modalCustomSize.isEdit = false;
      this.modalCustomSize.isButtonsDisabled = true;
      this.modalCustomSize.buttonText = "Enviar email";
      this.modalCustomSize.formTitle = "Esqueci minha Senha";

      this.modalCustomSize.forgotPassword.email = null;
    },
  },
};
</script>

<style>
.login-container {
  height: 100vh;
}

.left-panel {
  position: relative;
  padding: 0;
}

.background-right {
  height: 100%;
  background-color: #efeff0;
  background-image: url("../assets/bg_sigu.jpg");
  background-size: cover;
  background-blend-mode: normal;
  display: flex;
  justify-content: center;
  align-items: center;
  background-position: center;
}

.right-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
}

.background-left {
  width: 100%;
  height: 100%;
  background-color: #fafbff;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  background-position: center;
}

.rowLogin {
  max-width: 600px;
  height: 100%;
  display: flex;
  justify-content: space-between;
}

.fade-transition-row {
  height: 348px;
}

.tituloInicial {
  color: #000;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.nomeSistema {
  color: #3cbc62;
  display: inline;
  font-weight: 800;
}

.subtituloInicial {
  color: #95969b;
  text-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.labelCampo {
  color: #121212;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  padding-bottom: 8px;
}

#login-button {
  margin-top: 12px;
  width: 12em;
  background-color: #3cbc62;
  color: #fafbff;
}

#send-button {
  margin-top: 12px;
  width: 12em;
  background-color: #3cbc62;
  color: #fafbff;
}

.textoSuporte {
  color: #95969b;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-align: center;
}

.textoEmpresa {
  color: #95969b;
  font-size: 14px;
  font-style: normal;
  line-height: normal;
  text-align: center;
}
</style>
